import { Link } from "react-router-dom";
import "./Plot.css";
import { formatPrice } from "../utils/format";

const PlotCard = ({ plot, columnClass = "col-xl-4 col-md-6" }) => {
  return (
    <div className={`${columnClass} mt-60`}>
      <div className="project-card style1-1 plot-card-hover h-100">
        <div className="project-card-details h-100">
          <div className="d-flex justify-content-between align-items-start mb-2">
            <h4 className="box-title mb-0">
              <Link
                to={`/plots/${plot.id}`}
                state={{ plot }}
                style={{
                  color: "inherit",
                  textDecoration: "none",
                  transition: "color 0.3s ease-in-out",
                }}
              >
                Plot {plot.plotNumber}
              </Link>
            </h4>
            {plot.blockNumber && (
              <span className="plot-block-badge">Block {plot.blockNumber}</span>
            )}
          </div>

          {(plot.layout?.name || plot.estate?.name) && (
            <p className="plot-layout-name mb-2">
              <i
                className={`fas ${
                  plot.locationType === "ESTATE"
                    ? "fa-home"
                    : "fa-vector-square"
                } me-2`}
              ></i>
              {plot.locationType === "ESTATE" && plot.estate?.name
                ? plot.estate.name
                : plot.layout?.name}
            </p>
          )}
          <p className="property-location mb-3">
            <i className="fas fa-map-marker-alt me-2"></i>
            {plot.locationType && (
              <span className="me-2">{plot.locationType}</span>
            )}
            {plot.district ? `${plot.district}, ` : ""}
            {plot.lga}, {plot.state}
          </p>

          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="property-feature">
              <i className="fas fa-ruler-combined me-2"></i>
              {plot.sizeSqm} sqm
            </div>
            <div className="property-price ">
              <span>{formatPrice(plot.price)}</span> - 
              <span>
                {formatPrice(Number(plot.price) + Number(plot.price / 3))}
              </span>
            </div>
          </div>

          <div className="project-card-bottom">
            {/* <div className="project-status">
              <span className={`status-badge ${plot.status?.toLowerCase()}`}>
                {plot.status}
              </span>
            </div> */}
            <Link
              to={`/plots/${plot.id}`}
              className="th-btn btn-fill"
              state={{ plot }}
            >
              View Details <i className="fas fa-arrow-right ms-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlotCard;
